{
  "name": "galia-front-end",
  "version": "1.4.58",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:headless": "ng test --watch=false --browsers=ChromeHeadless",
    "test:sandbox": "CI=1 CHROME_SANDBOX_SHELL=1 ng test --watch=false --browsers=ChromeHeadlessSandboxed",
    "test:e2e": "playwright test",
    "browser:install": "bash scripts/install-headless-shell.sh",
    "lint": "ng lint",
    "format": "prettier --write \"src/**/*.{ts,html,css}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,css}\"",
    "translation:consistency": "node scripts/check-translations-consistency.js",
    "translation:unused": "node scripts/check-unused-translations.js",
    "translation:missing": "node scripts/check-missing-translations.js",
    "translation:all": "node scripts/check-all-translations.js",
    "translation:test": "node --test scripts/translation-ast-utils.test.js"
  },
  "private": true,
  "resolutions": {
    "mapbox-gl": "^3.23.0"
  },
  "dependencies": {
    "@angular/animations": "^21.2.11",
    "@angular/cdk": "^21.2.9",
    "@angular/common": "^21.2.11",
    "@angular/compiler": "^21.2.11",
    "@angular/core": "^21.2.11",
    "@angular/forms": "^21.2.11",
    "@angular/platform-browser": "^21.2.11",
    "@angular/router": "^21.2.11",
    "@antv/g6": "^5.1.0",
    "@faker-js/faker": "^10.4.0",
    "@floating-ui/dom": "^1.7.6",
    "@fontsource-variable/inter": "^5.2.8",
    "@fontsource-variable/lilex": "^5.2.1",
    "@mapbox/mapbox-gl-draw": "1.5.1",
    "@mapbox/mapbox-gl-language": "^1.0.1",
    "@ngrx/effects": "^21.1.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@phosphor-icons/web": "^2.1.2",
    "@tailwindcss/postcss": "^4.2.4",
    "@tailwindcss/typography": "^0.5.19",
    "@turf/turf": "^7.3.5",
    "ajv": "^8.20.0",
    "ajv-formats": "^3.0.1",
    "ajv-i18n": "^4.2.0",
    "angular-auth-oidc-client": "^21.0.1",
    "angular-split": "^20.0.0",
    "crypto-js": "^4.2.0",
    "date-fns": "^4.1.0",
    "jasmine-auto-spies": "^8.0.1",
    "mapbox-gl": "^3.23.0",
    "marked": "^18.0.14",
    "ngx-skeleton-loader": "^12.0.0",
    "papaparse": "^5.5.3",
    "postcss": "^8.5.12",
    "rxjs": "~7.8.2",
    "socket.io-client": "^4.8.3",
    "tailwindcss": "^4.2.4",
    "tslib": "^2.8.1",
    "vanilla-jsoneditor": "^3.12.0",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.3.1",
    "@angular-eslint/eslint-plugin": "21.3.1",
    "@angular-eslint/eslint-plugin-template": "21.3.1",
    "@angular-eslint/schematics": "21.3.1",
    "@angular-eslint/template-parser": "21.3.1",
    "@angular/build": "^21.2.9",
    "@angular/cli": "^21.2.9",
    "@angular/compiler-cli": "^21.2.11",
    "@eslint/eslintrc": "^3.3.5",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "1.63.0",
    "@trivago/prettier-plugin-sort-imports": "^6.0.2",
    "@types/crypto-js": "^4",
    "@types/jasmine": "^6.0.0",
    "@types/mapbox-gl": "^3.5.0",
    "@types/mapbox__mapbox-gl-draw": "^1.4.9",
    "@types/papaparse": "^5.5.2",
    "@typescript-eslint/eslint-plugin": "8.59.1",
    "@typescript-eslint/parser": "8.59.1",
    "@typescript-eslint/types": "^8.59.1",
    "@typescript-eslint/utils": "^8.59.1",
    "angular-eslint": "^21.3.1",
    "eslint": "10.2.1",
    "eslint-plugin-sort-class-members": "^1.22.1",
    "jasmine-core": "~6.2.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "playwright": "1.63.0",
    "prettier": "^3.8.3",
    "prettier-plugin-tailwindcss": "^0.8.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.59.1"
  },
  "packageManager": "yarn@4.5.1+sha512.341db9396b6e289fecc30cd7ab3af65060e05ebff4b3b47547b278b9e67b08f485ecd8c79006b405446262142c7a38154445ef7f17c1d5d1de7d90bf9ce7054d"
}
